import { useWidget } from '@telescope/cassini-hooks';
import { Container, Heading } from '@telescope/cassini-ui';
import { Link, Text } from 'components';
import { useParams } from 'react-router-dom';
import { ErrorType } from 'types'; 
import { Campaign } from 'types';

interface ErrorPageProps {
  /**
   * If provided, used as key to for looking up error copy in widget. If omitted, the page will default to checking the url params for an error type
   */
  errorType?: ErrorType;
  /**
   * Additional content to be displayed
   */
  children?: React.ReactNode;
}

export const ErrorPage = ({ children, errorType }: ErrorPageProps) => {
  const { errorType: errorTypeFromUrlParam } = useParams();
  const error = ((errorType || errorTypeFromUrlParam) ?? ErrorType.GENERIC) as ErrorType;
  const { data } = useWidget({
    select: (data: Campaign) => data.widget.global_views.errors.content[error],
  });
  const { copy, link } = data!;


  return (
    <>
      <Container as="section" className="ErrorPage__root" py={14} textAlign="center" flexGrow={2}>
        <Heading className="ErrorPage__headline" as="h1" size="xl" mb={2}>
          {copy.headline}
        </Heading>
        <Text className="ErrorPage__description" mb={12} allowMarkdown>
          {copy.description}
        </Text>

        <Link href={link.url} textDecoration="underline">{link.copy}</Link>

        {children}
      </Container>
    </>
  );
};
